module.exports = {
    zh_CN: { label: '简', lang: 'CN', geetest: 'zho' },
    zh_TW: { label: '繁', lang: 'CN', geetest: 'zho-tw' },
    en_US: { label: 'EN', lang: 'EN', geetest: 'eng' },
    vi_VN: { label: 'VI', lang: 'EN', geetest: 'eng' },
};



// WEBPACK FOOTER //
// ./src/common/languageMeta.js